<template>
  <div class="card">
    <div class="card-body">
      <div class="nav flex-column">
        <router-link
          v-for="tab in tabs"
          :key="tab.key"
          class="nav-link"
          :class="{ active: activeTab === tab.key }"
          :to="tab.route"
        >
          {{ tab.label ? tab.label : $t(tab.translationKey) }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalTabs',
  props: {
    activeTab: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    },
    locale: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.nav-link.active {
  background-color: #f8f9fa;
  color: #9fe870;
  font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/VerticalTabs.vue